import { type TAssert } from '../types';

import { AssertionError } from './assertion-error';

/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */

const assert: TAssert = function (condition, err) {
	if (!condition) {
		throw err;
	}
};

export { assert, AssertionError };
